import React from 'react';
import { ButtonTheme, ModalTheme, RenderForm } from '../../../components';
import { useForm } from 'react-hook-form';
import { shippingSelfQuery } from '../../../services/react-query/optionMasterQuery';
import { Spin } from 'antd';
import { ContainerButton } from '../../../styles/global-style';
import { useDownloadTemplate } from '../hooks/useDownloadTemplate';
import { useUpdateExcel } from '../hooks/useUpdateExcel';
import { UpdateExcel } from '../../../resources/payload';
import { FORM_IMPORT_EXCEL } from '../form';

export const ImportExcel = ({ open, onToggle }) => {
  const { control, setValue, getValues, handleSubmit } = useForm();
  const { data: shippingSelfList, isPending: isPendingShippingSelf } = shippingSelfQuery();
  const { mutate: downloadTemplate, loading: isPendingDownloadTemplate } = useDownloadTemplate();
  const { mutate: upDateExcel, loading: isPendingUpdateExcel } = useUpdateExcel();

  const onSubmit = () =>
    handleSubmit((values) => {
      const formData = UpdateExcel(values);
      upDateExcel(formData, {
        onSuccess: () => {
          onToggle({ defaultValue: '' });
        },
      });
    })();
  return (
    <Spin spinning={isPendingShippingSelf || isPendingDownloadTemplate || isPendingUpdateExcel}>
      <ModalTheme title="นำเข้าเลขพัสดุ" open={open} onToggle={onToggle}>
        <ContainerButton right>
          <ButtonTheme useFor="EX_IMPORT" onClick={() => downloadTemplate()} />
        </ContainerButton>
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_IMPORT_EXCEL({ shippingSelfList })}
        />
        <ContainerButton right style={{ marginTop: '40px' }}>
          {isPendingUpdateExcel ? (
            <Spin spinning={isPendingUpdateExcel} />
          ) : (
            <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
          )}
          <ButtonTheme useFor="CANCEL" onClick={onToggle} />
        </ContainerButton>
      </ModalTheme>
    </Spin>
  );
};
